module.exports = __webpack_public_path__ + "img/about-img-2.eef11ebf.jpg";